import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;
  handleUpdateActive: (e: { value: string | number; label: string }[]) => void;
  selectedActive: { value: string | number; label: string }[];
  handleUpdateCategories?: (
    e: { value: string | number; label: string }[]
  ) => void;
  selectedCategories?: { value: string | number; label: string }[];
  activeBeforeCategories?: boolean;
  handleApply: () => void;
}
const GamesCenterFilters: React.FC<Props> = ({
  searchValue,
  handleSearch,
  handleUpdateActive,
  selectedActive,
  handleUpdateCategories,
  selectedCategories,
  activeBeforeCategories = false,
  handleApply,
}) => {
  const { t } = useTranslation();

  const [Categories, setCategories] = useState<
    { value: string | number; label: string }[]
  >([]);

  const getCategories = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.categoriesList}?limit=500&offset=0`
      );
      const array = result.data.items.map((el: any) => {
        return {
          value: el.id,
          label: el.title,
        };
      });
      setCategories(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  
  useEffect(() => {
    if (selectedCategories) getCategories();
  }, [selectedCategories]);


  const handleApplyActive = (
    e: { value: string | number; label: string }[]
  ) => {
    handleUpdateActive(e);
  };
  const handleApplyCategories = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean
  ) => {
    if (handleUpdateCategories && selectedCategories)
      handleUpdateCategories(isDelete ? e : [...selectedCategories, ...e]);
  };

  const handleClearFilters = () => {
    if (handleUpdateCategories && selectedCategories)
      handleUpdateCategories([]);
    handleUpdateActive([
      {
        value: 3,
        label: "All",
      },
    ]);
    handleSearch("");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      className="game-center-filter"
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      search={searchValue}
      onSearch={handleSearch}
      placeholder={t("searchEntity")}
      searchLabel={t("title")}
      radioLabelsInFlow
      filterItems={
        handleUpdateCategories && selectedCategories
          ? [
              ...(activeBeforeCategories ? [
                {
                  type: FilterItemTypes.radio,
                  title: t("isActive"),
                  boxTitle: t("isActive"),
                  icon: gridIcon,
                  itemsArray: [
                    { label: "Active", value: 1 },
                    { label: "Inactive", value: 0 },
                    { label: "All", value: 3 },
                  ],
                  activeItems: selectedActive,
                  handleApply: handleApplyActive,
                },
              ] : []),
              {
                type: FilterItemTypes.multiselect,
                title: t("categories"),
                boxTitle: t("filterCategories"),
                icon: gridIcon,
                itemsArray: Categories,
                activeItems: selectedCategories,
                handleApply: handleApplyCategories,
                disabled: Categories.length === 0,
              },
              ...(!activeBeforeCategories ? [
                {
                type: FilterItemTypes.radio,
                title: t("isActive"),
                boxTitle: t("isActive"),
                icon: gridIcon,
                itemsArray: [
                  {
                    label: "Active",
                    value: 1,
                  },
                  {
                    label: "Inactive",
                    value: 0,
                  },
                  {
                    label: "All",
                    value: 3,
                  },
                ],
                activeItems: selectedActive,
                handleApply: handleApplyActive,
                },
              ] : []),
            ]
          : [
              {
                type: FilterItemTypes.radio,
                title: t("isActive"),
                boxTitle: t("isActive"),
                icon: gridIcon,
                itemsArray: [
                  {
                    label: "Active",
                    value: 1,
                  },
                  {
                    label: "Inactive",
                    value: 0,
                  },
                  {
                    label: "All",
                    value: 3,
                  },
                ],
                activeItems: selectedActive,
                handleApply: handleApplyActive,
              },
            ]
      }
    />
  );
};

export default GamesCenterFilters;
